<template>
    <ion-page>
        <Background></Background>
        <WhiteBackground></WhiteBackground>
        <FabColumn>
          <BackButton back_url="about/Home"></BackButton>
        </FabColumn>

        <ion-content class="delete-account-content">
            <div class="main">
                <MainTitle class="delete-account-title" text="您確定要刪除帳戶嗎?" margin_top="short"></MainTitle>
                <div class="scroll-box enable-scroll">
                    <div class="deleteAccount">
                        <span>當刪除帳戶後︰</span><br>
                        <span>· 電話號碼會被刪除</span><br>
                        <span>· 所有測試者資料(包括測試者全名、性別、出生年份、手提電話號碼、教育程度、居住地區、參考編號、測試結果等)會被刪除</span><br>
                        <span>· 無法查詢測試結果</span><br>
                        <span>· 無法瀏覽腦部健康小貼士</span><br>
                        <span>· 如您已參加賽馬會「智康健」腦退化檢測及社區支援計劃，於程式內的相關認知能力測試記錄亦會受影響。</span><br><br>
                        <span>帳戶將於兩星期內被刪除</span><br><br>
                        <label class="delete-account-consent">
                            <input type="checkbox" v-model="isChecked">
                            <span>本人確定要刪除帳戶。本人已閱讀並知悉所有資料將會被刪除及無法再進行測試及査詢相關測試結果，而本人在賽馬會「智康健」腦退化檢測及社區支援計劃的服務亦會受到影響（如有）。</span>
                        </label>
                    </div>
                    <div class="button-box">
                        <ion-button class="button" :disabled="!isChecked" @click="closeModal">確定</ion-button>
                    </div>
                </div>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import { IonPage, IonContent, IonButton } from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import BackButton from "../components/common/BackButton";
import MainTitle from "../components/common/MainTitle";
import common from "../common";
import router from "../router";

export default {
    name: "DeleteAccount",
    components: {
        IonPage,
        IonContent,
        IonButton,
        Background,
        WhiteBackground,
        BackButton,
        MainTitle,
    },
    data() {
        return {
            isChecked: false
        }
    },
    ionViewWillEnter() {
        common.getStorage(common.config.token_key).then(val => {
            if (val === null) {
                return common.showAlert('帳戶未有登入，請先登入', '錯誤', function () {
                    router.replace('/about/Login');
                })
            }
        })
    },
    methods: {
        closeModal: function () {
            common.apiPostData('/deleteAccount', '', true).then(res => {
                if (res === false) {
                    this.isChecked = false;
                    return false;
                }
                common.showAlert('帳戶删除成功', '提示', function () {
                    common.clearSession();
                    router.replace('/loginPrepare');
                });

            })
        }
    },
}
</script>

<style scoped>
.delete-account-content {
    --overflow: hidden;
    --padding-start: 0;
    --padding-end: 0;
    --padding-top: 0;
    --padding-bottom: 0;
}

.main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    width: 80%;
    height: 100%;
    margin: 0 auto;
    padding: 0;
    min-height: 0;
}

.delete-account-title {
    min-height: 0;
    margin-top: 2vh;
    margin-bottom: 2vh;
    padding-top: clamp(0.5rem, 1.5vw, 1rem);
    padding-bottom: clamp(0.5rem, 1.5vw, 1rem);
}

.scroll-box {
    width: min(100%, 42rem);
    flex: 0 1 auto;
    max-height: min(54vh, 28rem);
    min-height: 0;
    overflow-y: auto;
    padding-right: clamp(0.5rem, 1vw, 0.75rem);
    box-sizing: border-box;
}

.deleteAccount {
    margin: 0 auto;
    width: 100%;
    font-size: var(--ecs-font-md);
    line-height: 1.35;
}

.delete-account-consent {
    display: flex;
    align-items: flex-start;
    gap: 0.4rem;
    cursor: default;
}

.delete-account-consent input {
    flex: 0 0 auto;
    margin-top: 0.35em;
}

.button-box {
    display: flex;
    width: var(--ecs-control-width-sm);
    max-width: 90vw;
    align-items: center;
    justify-content: center;
    margin: clamp(1rem, 2vw, 2rem) auto 0;
}

.button {
    --background: #94c43b;
    --padding-top: clamp(0.5rem, 1.4vw, 0.875rem);
    --padding-bottom: clamp(0.5rem, 1.4vw, 0.875rem);
    width: 100%;
    min-height: var(--ecs-button-min-height);
    height: auto;
    white-space: normal;
    font-size: var(--ecs-font-md);
    line-height: 1.3;
}
</style>
